import { getConsumptions, getConsumptionsAPIError } from "@edp-store/selectors/consumption.selectors";
import {
    getContract,
    getContractAPIError,
    getContractDetails,
    getContractDetailsAPIError,
    getPartnerInfo,
    getPartnerInfoAPIError,
} from "@edp-store/selectors/contract.selectors";
import {
    getBalance,
    getBalanceAPIError,
    getCampaigns,
    getCampaignsAPIError,
    getContractRequestsAPIError,
    getElectricMobilityWidget,
    getElectricMobilityWidgetAPIError, getFunciona,
    getFuncionaAPIError, getInvoices,
    getInvoicesAPIError, getUnexpiredContractRequests
} from "@edp-store/selectors/dashboard.selectors";
import { getOnboardingWhatsNew, getWhatsNewlastAPIError } from "@edp-store/selectors/onboaring.selectors";
import { getSmartNowAPIError, getSmartNowStatus } from "@edp-store/selectors/smart-now.selector";
import { DependencyList } from "../types/DependencyList.interface";

const exp: DependencyList = {
    smartNowDep: {
        selector: getSmartNowStatus,
        errorSelector: getSmartNowAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
        onFail: () => null,
    },
    partner: {
        selector: getPartnerInfo,
        errorSelector: getPartnerInfoAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
    },
    contract: {
        selector: getContract,
        errorSelector: getContractAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
    },
    unexpiredContractRequests: {
        selector: getUnexpiredContractRequests,
        errorSelector: getContractRequestsAPIError,
        data: [],
        observable: null,
        initPromise: null,
        requiredOnInit: false,
    },
    invoices: {
        selector: getInvoices,
        errorSelector: getInvoicesAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
    },
    balanceData: {
        selector: getBalance,
        errorSelector: getBalanceAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
    },
    funciona: {
        selector: getFunciona,
        errorSelector: getFuncionaAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
        onFail: () => null,
    },
    contractDetails: {
        selector: getContractDetails,
        errorSelector: getContractDetailsAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
        onFail: () => null,
    },
    campaigns: {
        selector: getCampaigns,
        errorSelector: getCampaignsAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
    },
    consumptions: {
        selector: getConsumptions,
        errorSelector: getConsumptionsAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
        onFail: () => null,
    },
    electricMobility: {
        selector: getElectricMobilityWidget,
        errorSelector: getElectricMobilityWidgetAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
        onFail: () => null,
    },
    onboardingWhatsNew: {
        selector: getOnboardingWhatsNew,
        errorSelector: getWhatsNewlastAPIError,
        data: null,
        observable: null,
        initPromise: null,
        requiredOnInit: false,
        onFail: () => null,
    },
};

export default exp;
